module.exports = __webpack_public_path__ + "img/red_heart.f1b45428.png";